var request = require('./request');
var config = require('./config');
var resolve = require('./resolve');

exports.GetConversations = function(filter) {
	return request.get(resolve(config.url(),'/messages/conversation/?filter=' + filter)).promise();
}
exports.GetConversation = function(conversationId, lastMessageRetrieved) {
  var qry = {
      lastMessage: lastMessageRetrieved
    }
	return request.get(resolve(config.url(),'/messages/' + conversationId), qry).promise();
}

exports.StartNewConversation = function(applicationId, funderId) {
  var conversation = {
      applicationId: applicationId,
      funderId: funderId 
    };
  return request.post(resolve(config.url(), '/messages/conversation'), conversation).promise();
}

exports.StartNewFunderConversation = function(myFunderId, funderId) {
  var conversation = {
      myFunderId: myFunderId,
      funderId: funderId 
    };
  return request.post(resolve(config.url(), '/messages/funderconversation'), conversation).promise();
}

exports.SendMessage = function(conversationId, message){
  var message = {
    messageText: message.text,
    conversationId: conversationId,
    attachment: message.attachment
  }
  return request.post(resolve(config.url(), '/messages'), message).promise();
}

exports.GetFunderApplicationConversation = function(applicationId, funderId){
  var qry = {
      applicationId: applicationId,
      funderId: funderId
    }
	return request.get(resolve(config.url(),'/messages/funderapplicationconversation'), qry).promise();
  
}

exports.GetApplicationConversations = function(applicationId) {
  var qry = {
      applicationId: applicationId
    }
	return request.get(resolve(config.url(),'/messages/applicationconversation'), qry).promise();
}

exports.GetFunderFunderConversation = function(myFunderId, funderId){
  var qry = {
      myFunderId: myFunderId,
      funderId: funderId
    }
	return request.get(resolve(config.url(),'/messages/funderfunderconversation'), qry).promise();
  
}

exports.GetFunderConversations = function(funderId) {
  var qry = {
      funderId: funderId
    }
	return request.get(resolve(config.url(),'/messages/funderconversations'), qry).promise();
}

exports.GetApplicationMessageAttachments = function(applicationId){
  return request.get(resolve(config.url(),'/messages/attachments/' + applicationId)).promise();
}

exports.GetFunderMessageAttachments = function(funderId, applicationId){
  var qry = {
    funderId: funderId,
    applicationId: applicationId
  }
  return request.get(resolve(config.url(),'/messages/funderattachments'), qry).promise();
}
